import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-muster-attendance-date-wise-summary',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, NgbDropdownModule, NgSelectModule, LoaderComponent],
  providers: [DatePipe],
  templateUrl: './muster-attendance-date-wise-summary.component.html',
  styleUrl: './muster-attendance-date-wise-summary.component.scss'
})
export class MusterAttendanceDateWiseSummaryComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() dateKeys: any[] = [];
  @Input() Index: number = 0;
  @Input() SiteMasterID: number = 0;
  @Input() UpdateRecodes = [] as any;
  @Input() LeaveBalance: any[] = [];
  @Input() IsLocked: boolean = false;
  @Input() SiteName: string = '';
  @Input() CompanyPermiter = {
    IsAttendanceBeforeDaysAllowed: false,
    AttendanceBeforeDays: 0,
    IsAttendanceAfterDaysAllowed: false,
    AttendanceAfterDays: 0,
    IsUpdateDesignationDutyAllowed: false,
    IsAttendanceResetAllowed: false,
    IsAttendanceDeleteAllowed: false,
    IsAttendanceForSameDayAllowed: false,
    TodayDate: null,
    IsRelievingOTDisable: false
  } as any;
  @Input() filter = [] as any;

  SummaryData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  user = [] as any;
  AttendanceTypes = [] as any;
  uniqDD = [] as any;

  constructor(
    private musterAttendance: MusterAttendanceService,
    private combo: ComboService,
    private session: SessionService,
    protected common: CommonService,
    protected datePipe: DatePipe,
    private toast: ToastService,
    private modalService: NgbModal,
    protected dateFormate: CustomDateParserFormatter,
  ) {
    this.user = this.session.GetUserDetails();
    //this.common.getPageRights();
  }

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    info: false,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    ordering: false,
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columns: [{
      title: '#',
      data: null,
      render: (data, type, row, meta) => {
        return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
      },
      orderable: true,
    }, {
      title: 'Detail',
      data: null,
      render: (data, type, row, meta) => {
        let profileImage = '';
        if (row.Photo) {
          profileImage = `
              <img class="userImage" 
                  style="width: 30px;height: 30px;"
                   src="${this.common.PhotoLink(row.Photo)}" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-profile="true" />
            `;
        } else {
          profileImage = `
              <div class="initial-image" 
                  style="width: 30px;height: 30px;"
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-profile="true">
                <div class="image">${this.common.getInitial(row.FullName)}</div>
              </div>
            `;
        }
        // Return the complete structure
        return `
            <div class="row no-gutters cursor-pointer" style="align-items: center; width: 230px;">
              <div class="col-3">
                ${profileImage}
              </div>
              <div class="col-9 userdetail p-0">
                <span class="text-label" style="font-size: xx-small !important;">${row.FullName || ''}</span><br />
                <span class="text-label-light" style="font-size: xx-small !important;">#${row.EmpCode || ''}</span>
              </div>
            </div>
          `;
      },
      orderable: true,
    },
    {
      title: 'Designation',
      data: 'DesignationName',
      orderable: true,
    }, {
      title: 'Duty',
      data: 'DutyName',
      orderable: true,
    },
    {
      title: 'Shift',
      data: null,
      render: (data, type, row, meta) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
            const selectId = `shifts-${meta.row}`;

            const options = row.Shifts.map((type: any) =>
              `<option value=${type.ShiftMasterID} ${row.ShiftMasterId === type.ShiftMasterID ? 'selected' : ''}>
              ${type.ShiftTitle}
            </option>`
            ).join('');
            const isSelected = row.ShiftMasterId ? '' : 'selected';

            return `
            <select class="form-select" name="shifts-${meta.row}" id="${selectId}" style="font-size:xx-small">
              <option value=null ${isSelected}>--select--</option>
              ${options}
            </select>
          `;
          } else {
            return row.ShiftTitle;
          }
        } else {
          return row.ShiftTitle;
        }
      },
      orderable: false,
      createdCell: (td, cellData, rowData, rowIndex, colIndex) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
            $(td).find('select').on('change', (e) => {
              rowData.ShiftMasterId = parseInt(e.target.value) || 0;
              this.UpdateRecode(rowData);
            });
          }
        }
      }
    },
    {
      title: 'Status',
      data: null,
      render: (data, type, row, meta) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
            const selectId = `attendance-type-${meta.row}`;

            const options = this.AttendanceTypes.map((type: any) =>
              `<option value="${type.AttendanceType}" ${row.AttendanceRemark === type.AttendanceType ? 'selected' : ''}>
            ${type.AttendanceTypeName}
          </option>`
            ).join('');

            return `
            <select class="form-select" aria-label="AttendanceType" title="AttendanceType"
                    name="attendanceType-${meta.row}" id="${selectId}"  style="font-size:xx-small">
              <option value="" selected>--select--</option>
              ${options}
            </select>
          `;
          } else {
            return row.AttendanceRemark;
          }
        } else {
          return row.AttendanceRemark;
        }
      },
      orderable: false,
      createdCell: (td: any, cellData, rowData, rowIndex, colIndex) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
            $(td).find('select').on('change', async (e) => {
              rowData.AttendanceRemark = e.target.value;
              if (!this.CompanyPermiter.IsAttendanceForSameDayAllowed && this.common.ToLowerCase(rowData.AttendanceRemark) != 'a' && rowData.AttendanceRemark != null && rowData.AttendanceRemark != ''
                && rowData.AttendanceRemark != rowData.B_AttendanceRemark) {
                if (await this.ESS_ValidateSaveAttendanceOAS('AllowAttendanceForSameDay', this.convertDateFormate(rowData.AttendanceDate) ?? '', rowData.AttendanceRemark, rowData)) {
                  this.UpdateRecode(rowData, td);
                } else {
                  rowData.AttendanceRemark = 'A';
                  $(td).find('select').val('A');
                  this.UpdateRecode(rowData, td)
                }
              } else {
                this.UpdateRecode(rowData, td);
              }
            });
          }
        }
      }
    },
    {
      title: 'InTime',
      data: null,
      render: (data, type, row, meta) => {
        if (row.InTime != null && row.InTime != '')
          return this.convertDateFormate(row.InTime, true);
        else
          return '';
      },
      orderable: true,
    }, {
      title: 'OutTime',
      data: null,
      render: (data, type, row, meta) => {
        if (row.OutTime != null && row.OutTime != '')
          return this.convertDateFormate(row.OutTime, true);
        else
          return '';
      },
      orderable: true,
    }, {
      title: 'OTHours',
      data: null,
      className: 'text-end',
      render: (data, type, row, meta) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
            const inputId = `ot-hours-${meta.row}`;
            return `
            <div class="input-group">
              <input type="number" 
                    class="form-control ot-hours-input" 
                    id="${inputId}"
                    value="${row.OTHours || 0}" 
                    min="0"
                    max="24"
                    step="0.5"
                    data-row-id="${meta.row}"
                    placeholder="OT Hours"
                    style="font-size:xx-small">
            </div>
          `;
          } else {
            return row.OTHours || 0;
          }
        } else {
          return row.OTHours || 0;
        }
      },
      orderable: true,
      createdCell: (td, cellData, rowData, rowIndex, colIndex) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
            const input = $(td).find('.ot-hours-input');

            input.on('change', (event: any) => {
              const value = parseFloat(event.target.value) || 0;

              if (value < 0) {
                event.target.value = '0';
                rowData.OTHours = 0;
              } else if (value > 24) {
                event.target.value = '24';
                rowData.OTHours = 24;
              } else {
                rowData.OTHours = value;
              }
              this.UpdateRecode(rowData);
            });

            input.on('blur', (event: any) => {
              if (event.target.value === '') {
                event.target.value = '0';
                rowData.OTHours = 0;
                this.UpdateRecode(rowData);
              }
            });
          }
        }
      }
    },
    {
      title: 'Relieving Hours',
      data: null,
      className: 'text-end',
      render: (data, type, row, meta) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
          && !this.CompanyPermiter.IsRelievingOTDisable
        ) {
          if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
            const inputId = `relieving-hours-${meta.row}`;
            return `
          <div class="input-group">
            <input type="number" 
                  class="form-control relieving-hours-input" 
                  id="${inputId}"
                  value="${row.RelievingHours || 0}" 
                  min="0"
                  max="24"
                  step="0.5"
                  data-row-id="${meta.row}"
                  placeholder="Relieving Hours"
                  style="font-size:xx-small">
          </div>
        `;
          } else {
            return row.RelievingHours || 0;
          }
        } else {
          return row.RelievingHours || 0;
        }
      },
      orderable: true,
      createdCell: (td, cellData, rowData, rowIndex, colIndex) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
          && !this.CompanyPermiter.IsRelievingOTDisable
        ) {
          if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
            const input = $(td).find('.relieving-hours-input');

            input.on('change', (event: any) => {
              const value = parseFloat(event.target.value) || 0;

              if (value < 0) {
                event.target.value = '0';
                rowData.RelievingHours = 0;
              } else if (value > 24) {
                event.target.value = '24';
                rowData.RelievingHours = 24;
              } else {
                rowData.RelievingHours = value;
              }
              this.UpdateRecode(rowData);
            });

            input.on('blur', (event: any) => {
              if (event.target.value === '') {
                event.target.value = '0';
                rowData.RelievingHours = 0;
                this.UpdateRecode(rowData);
              }
            });
          }
        }
      }
    }]
  };

  ngOnInit(): void {
    this.ComboLoadAsync('Attendance Type');
  }

  ngOnDestroy(): void {
    if ($.fn.dataTable.isDataTable('#summarydata')) {
      $('#summarydata').DataTable().destroy();
    }
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.UpdateRecodes.filter((e: any) => e.IsUpdate).findIndex((e: any) => (e.ShiftMasterId == 0 || e.ShiftMasterId == '' || e.ShiftMasterId == null) && (e.AttendanceRemark != "" || e.AttendanceRemark != null)) < 0) {
        this.close(true);
      } else {
        this.toast.show({ message: 'Please select shift for all employee who mark attendance or remove attendance.', type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_LoadAttendanceOAS() {
    this.isDisabled = true;
    this.SummaryData = [];

    this.musterAttendance.ESS_LoadAttendanceOAS({
      'SelectType': 'DD', SiteId: this.SiteMasterID,
      MonthName: null, YearName: null,
      EmpMasterId: 0, AttendanceDate: this.dateKeys[this.Index], DesignationMasterId: 0, DutyMasterId: 0, ShiftMasterId: 0,
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.SummaryData = response.Table.length > 0 ? response.Table.map((item: any) => ({ ...item, Shifts: [] })) : [];

          this.UpdateRecodes.forEach((element: any) => {
            const index = this.SummaryData.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId && this.convertDateFormate(e.AttendanceDate) == element.AttendanceDate);
            if (index >= 0) {
              this.SummaryData[index].AttendanceRemark = element.AttendanceRemark;
              if (element.ShiftMasterId > 0) {
                this.SummaryData[index].ShiftMasterId = element.ShiftMasterId;
              }
              if (element.OTHours != null && element.OTHours != '') {
                this.SummaryData[index].OTHours = element.OTHours;
              }
              if (element.RelievingHours != null && element.RelievingHours != '') {
                this.SummaryData[index].RelievingHours = element.RelievingHours;
              }
            }
          });

          this.SummaryData = this.SummaryData.map((item: any) => {
            return {
              ...item,
              B_AttendanceRemark: item.AttendanceRemark
            };
          });

          this.uniqDD = Array.from(new Map(this.SummaryData.map((item: any) => [`${item.DesignationMasterId}-${item.DutyMasterId}`, { DesgnationID: item.DesignationMasterId, DutyID: item.DutyMasterId }])).values());
          this.loadAllShiftsSequentially();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async loadAllShiftsSequentially() {
    if (!this.IsLocked && this.common.PageRight.IsEdit) {

      for (let i = 0; i < this.uniqDD.length; i++) {
        await this.ComboLoadAsync("ShiftLoadBasedOnDesignationDuty", i);
      }

      for (let i = 0; i < this.SummaryData.length; i++) {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, this.SummaryData[i].AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          try {
            //await this.ComboLoadAsync("ShiftLoadBasedOnDesignationDuty", i);
            const uniqddindex = this.uniqDD.findIndex((e: any) => e.DesgnationID == this.SummaryData[i].DesignationMasterId && e.DutyID == this.SummaryData[i].DutyMasterId);
            if (uniqddindex >= 0) {
              this.SummaryData[i].Shifts = this.uniqDD[uniqddindex].Shifts;
            }

            if (
              this.SummaryData[i].Shifts.findIndex((e: any) => e.ShiftMasterID == this.SummaryData[i].ShiftMasterId) < 0
            ) {
              this.SummaryData[i].ShiftMasterId = null;
            }
          } catch (err) {
            console.error('Error loading shift for row', i, err);
          }
        }
      }
    }
    this.initializeDataTable('#summarydata', Object.values(this.SummaryData));
  }


  ComboLoadAsync(Combotype: string, Index = 0): Promise<any> {
    this.isDisabled = true;

    return new Promise((resolve, reject) => {
      this.combo.ComboLoad({
        Combotype: Combotype,
        EmpMasterID: this.user.UserId,
        SiteId: this.SiteMasterID,
        //DesignationId: this.SummaryData.length == 0 ? 0 : this.SummaryData[Index].DesignationMasterId,
        //DutyId: this.SummaryData.length == 0 ? 0 : this.SummaryData[Index].DutyMasterId
        DesignationId: this.SummaryData.length == 0 ? 0 : this.uniqDD[Index].DesgnationID ?? 0,
        DutyId: this.SummaryData.length == 0 ? 0 : this.uniqDD[Index].DutyID ?? 0
      }).subscribe({
        next: (response) => {
          if (Combotype === 'Attendance Type') {
            this.AttendanceTypes = response.ComboLoad;
            this.ESS_LoadAttendanceOAS();
          } else if (Combotype === 'ShiftLoadBasedOnDesignationDuty') {
            this.uniqDD[Index].Shifts = response.ComboLoad;
            //this.SummaryData[Index].Shifts = response.ComboLoad;
            // if (
            //   this.SummaryData[Index].Shifts.findIndex((e: any) => e.ShiftMasterID == this.SummaryData[Index].ShiftMasterId) < 0
            // ) {
            //   this.SummaryData[Index].ShiftMasterId = null;
            // }
          }
          this.isDisabled = false;
          resolve(true); // Resolve after data is loaded
        },
        error: (err) => {
          this.isDisabled = false;
          reject(err);
        }
      });
    });
  }


  initializeDataTable(selector: string, data: any[]) {
    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().destroy();
    }
    const table = $(selector).DataTable({
      data: data,
      ...this.dtOptions
    });
  }

  convertDateFormate(Date: string, WithTime = false) {
    if (!WithTime) {
      return this.datePipe.transform(Date, 'dd MMM yyyy')
    } else {
      return this.datePipe.transform(Date, 'dd MMM yyyy, HH:mm:ss')
    }
  }


  close(flag = false) {
    if (flag) {
      this.activeModal.close(this.UpdateRecodes);
    } else {
      this.activeModal.close([]);
    }
  }

  changeEmp(index: number) {
    if (this.Index > 0 && index == -1) {
      this.Index -= 1;
      this.ESS_LoadAttendanceOAS();
    } else if (this.Index < this.dateKeys.length - 1 && index == 1) {
      this.Index += 1;
      this.ESS_LoadAttendanceOAS();
    }
  }

  async UpdateRecode(data: any, td = null) {
    let IsAllow = false;
    const index = this.UpdateRecodes.findIndex((e: any) => e.EmpMasterId == data.EmpMasterId && e.DesignationMasterId == data.DesignationMasterId && e.DutyMasterId == data.DutyMasterId && e.AttendanceDate == this.convertDateFormate(data.AttendanceDate));
    //const uindex = this.UpdateRecodes.findIndex((e: any) => e.EmpMasterId == data.EmpMasterId && e.DesignationMasterId == data.DesignationMasterId && e.DutyMasterId == data.DutyMasterId && e.AttendanceDate == data.AttendanceRemark);
    const sindex = this.SummaryData.findIndex((e: any) => e.EmpMasterId == data.EmpMasterId && e.DesignationMasterId == data.DesignationMasterId && e.DutyMasterId == data.DutyMasterId && this.convertDateFormate(e.AttendanceDate) == this.convertDateFormate(data.AttendanceDate))
    const bindex = this.LeaveBalance.findIndex(e => e.EmpMasterId == data.EmpMasterId);

    if ((index >= 0 || sindex >= 0) && bindex >= 0) {
      if (this.CompanyPermiter.IsCheckingLeaveBalanceInMusterApplicable) {
        if (index >= 0
          && this.AttendanceTypes.filter((e: any) => e.LeaveAttendanceType
            && this.common.ToLowerCase(e.AttendanceType) == this.common.ToLowerCase(this.UpdateRecodes[index].AttendanceRemark)).length > 0) {
          this.LeaveBalance[bindex][this.UpdateRecodes[index].AttendanceRemark + '_LeaveBalance'] += 1;
        } else if (sindex >= 0 && index == -1
          && this.AttendanceTypes.filter((e: any) => e.LeaveAttendanceType
            && this.common.ToLowerCase(e.AttendanceType) == this.common.ToLowerCase(this.SummaryData[sindex].B_AttendanceRemark)).length > 0) {
          this.LeaveBalance[bindex][this.SummaryData[sindex].B_AttendanceRemark + '_LeaveBalance'] += 1;
        }
      }
    }

    if (this.CompanyPermiter.IsCheckingLeaveBalanceInMusterApplicable
      && this.AttendanceTypes.filter((e: any) => e.LeaveAttendanceType
        && (this.common.ToLowerCase(e.AttendanceType) == this.common.ToLowerCase(data.AttendanceRemark) || this.common.ToLowerCase(e.AttendanceType) == this.common.ToLowerCase(data.B_AttendanceRemark))).length > 0) {

      IsAllow = await this.ESS_ValidateSaveAttendanceOAS('LeaveValidation', this.convertDateFormate(data.AttendanceDate) ?? '', data.AttendanceRemark, data);


      if (IsAllow) {
        if (bindex >= 0) {
          if (this.LeaveBalance[bindex][data.AttendanceRemark + '_LeaveBalance'] >= 1) {
            this.LeaveBalance[bindex][data.AttendanceRemark + '_LeaveBalance'] -= 1;
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = 'Leave Balance Exceeded for ' + data.AttendanceRemark;
            modalRef.componentInstance.Message2 = "Employee <b>" + data.EmpCode + "-" + data.FullName + ".<br/> Date: " + this.convertDateFormate(data.AttendanceDate);
            modalRef.result.then((result: any) => { });

            data.AttendanceRemark = data.B_AttendanceRemark;
            if (td != null) {
              $(td).find('select').val(data.AttendanceRemark);
            }
          }
        }
      }
    }

    if (index == -1) {
      this.UpdateRecodes.push({
        DailyAttendanceInOutID: data.DailyAttendanceInOutID,
        EmpMasterId: data.EmpMasterId,
        DesignationMasterId: data.DesignationMasterId,
        DutyMasterId: data.DutyMasterId,
        ShiftMasterId: data.ShiftMasterId,
        AttendanceRemark: data.AttendanceRemark,
        AttendanceDate: this.convertDateFormate(data.AttendanceDate),
        OTHours: data.OTHours,
        RelievingHours: data.RelievingHours,
        IsUpdate: true,
        Index: this.Index
      });
    } else if (index >= 0) {
      this.UpdateRecodes[index].ShiftMasterId = data.ShiftMasterId;
      this.UpdateRecodes[index].AttendanceRemark = data.AttendanceRemark;
      this.UpdateRecodes[index].OTHours = data.OTHours;
      this.UpdateRecodes[index].RelievingHours = data.RelievingHours;
      this.UpdateRecodes[index].ShiftMasterId = data.ShiftMasterId;
      this.UpdateRecodes[index].IsUpdate = true;
    }
  }

  CheckJoinLeftDate(Day: any, JoiningDate: any, LeftDate: any) {
    return new Date(Day).getTime() >= new Date(JoiningDate).getTime() && (LeftDate == null || new Date(Day).getTime() <= new Date(LeftDate).getTime());
  }

  getDayDifference(d1: string, d2: string): number {
    d2 = this.convertDateFormate(d2) ?? d2;
    const date1 = new Date(d1);
    const date2 = new Date(d2);

    // Reset hours to 0 to avoid time-related issues
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    const msPerDay = 1000 * 60 * 60 * 24;
    const diff = (date2.getTime() - date1.getTime()) / msPerDay;

    return diff; // positive = date2 after date1, negative = date2 before date1
  }

  async ESS_ValidateSaveAttendanceOAS(SelectType: string, AttendanceDate: string, AttendanceRemark: string, employee: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_ValidateSaveAttendanceOAS({
        'SelectType': SelectType, SiteId: this.SiteMasterID,
        AttendanceDate: AttendanceDate, AttendanceRemark: AttendanceRemark,
        EmpMasterId: employee.EmpMasterId, DailyAttendanceInOutId: employee.DailyAttendanceInOutID,
        MonthName: this.dateFormate.fullmonth[this.filter.MonthYear.month - 1], YearName: this.filter.MonthYear.year
      }).subscribe({
        next: (response) => {
          if (response.Table[0].Column1 == '01') {
            resolve(true);
          } else {
            resolve(false);
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Table2[0].Column1;
            modalRef.componentInstance.Message2 = "Employee <b>" + employee.EmpCode + "-" + employee.FullName + "</b> is already present at site <b>" + response.Table[0].SiteCode + "-" + response.Table[0].SiteName + "<b/>. Date: " + AttendanceDate;
            modalRef.result.then((result: any) => { });
          }
        },
        complete: () => { },
        error: (error) => {
          resolve(error);
        },
      });
    });
  }
}
